import Icon from '../components/Icon.vue'

Icon.register({"simplybuilt":{"width":2048,"height":1792,"paths":[{"d":"M863 1032q0-112-79.5-191.5t-191.5-79.5-191 79.5-79 191.5 79 191 191 79 191.5-79 79.5-191zM1726 1031q0-112-79-191t-191-79-191.5 79-79.5 191q0 113 79.5 192t191.5 79 191-79.5 79-191.5zM2048 222v1348q0 44-31.5 75.5t-76.5 31.5h-1832q-45 0-76.5-31.5t-31.5-75.5v-1348q0-44 31.5-75.5t76.5-31.5h431q44 0 76 31.5t32 75.5v161h754v-161q0-44 32-75.5t76-31.5h431q45 0 76.5 31.5t31.5 75.5z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/simplybuilt.js
// module id = 1709
// module chunks = 0